import Integrations from './Integrations';
export default Integrations;
